import React, { useContext, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../../../assets/css/admin/dashboard/Subadmin.css';
import AdminLayout from "../../../layouts/admin/AdminLayout";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const SubAdmins = () => {

  const { baseUrl } = useContext(AppContext);

  const [Name,     setName]     = useState('');
  const [Email,    setEmail]    = useState('');
  const [Password, setPassword] = useState('');
  const [Role,     setRole]     = useState('');
  const [Status,   setStatus]   = useState('');

  const [subAdmins,    setSubAdmins]    = useState([]);
  const [pageLoading,  setPageLoading]  = useState(true);
  const [isLoading,    setIsLoading]    = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [sgcShowAdd,   setSgcShowAdd]   = useState(false);
  const [sgcShowEdit,  setSgcShowEdit]  = useState(false);
  const [sgcEditData,  setSgcEditData]  = useState({});
  const [addBtnLoading, setAddBtnLoading] = useState(false);

  const viewAllSubAdmin = () => {
    axios
      .get(`${baseUrl}/admin/subAdmin/viewAllSubAdmin`)
      .then((res) => {
        setSubAdmins(res.data);
        setPageLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setPageLoading(false);
      });
  };

  useEffect(() => {
    viewAllSubAdmin();
  }, []);

  const createSubAdmin = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('name',     Name);
    formData.append('email',    Email);
    formData.append('password', Password);
    formData.append('role',     Role);
    formData.append('status',   Status);

    axios
      .post(`${baseUrl}/admin/subAdmin/createSubAdmin`, formData)
      .then(() => {
        viewAllSubAdmin();
        setSgcShowAdd(false);
        setName(''); setEmail(''); setPassword(''); setRole(''); setStatus('');
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const updateSubAdmin = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('id',       sgcEditData.id);
    formData.append('name',     Name);
    formData.append('email',    Email);
    formData.append('password', Password);
    formData.append('role',     Role);
    formData.append('status',   Status);

    axios
      .post(`${baseUrl}/admin/subAdmin/updateSubAdmin`, formData)
      .then(() => {
        viewAllSubAdmin();
        setSgcShowEdit(false);
        setName(''); setEmail(''); setPassword(''); setRole(''); setStatus('');
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const sgcOpenEdit = (admin) => {
    setSgcEditData(admin);
    setName(admin.name);
    setEmail(admin.email);
    setPassword('');
    setRole(admin.role);
    setStatus(admin.status);
    setSgcShowEdit(true);
  };

  const deleteSubAdmin = (id) => {
    axios
      .delete(`${baseUrl}/admin/subAdmin/deleteSubAdmin/${id}`)
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
      })
      .catch((error) => console.log(error));
  };

  const handleOpenAdd = () => {
    setAddBtnLoading(true);
    setTimeout(() => {
      setSgcShowAdd(true);
      setAddBtnLoading(false);
    }, 600);
  };

  return (
    <AdminLayout>
      <div className="subadmin-wrapper">
        <Container fluid>

          {/* HEADER */}
          <div className="subadmin-header">
            <div>
              <h2 className="subadmin-title">Sub-Admins</h2>
              <p className="subadmin-subtitle">Manage your team members and roles.</p>
            </div>
            <button className="subadmin-add-btn" onClick={handleOpenAdd} disabled={addBtnLoading}>
              {addBtnLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Loading...
                </>
              ) : (
                <>
                  <FiPlus size={16} /> Add New
                </>
              )}
            </button>
          </div>

          {/* TABLE CARD */}
          <Row>
            <Col xs={12}>
              <div className="subadmin-card">
                {pageLoading ? (
                  <div style={{ textAlign: "center", padding: "40px 0" }}>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    Loading...
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="subadmin-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Password</th>
                          <th>Role</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {subAdmins.map((admin) => (
                          <tr key={admin.id}>
                            <td className="subadmin-name">{admin.name}</td>
                            <td className="subadmin-email">{admin.email}</td>
                            <td className="subadmin-password">••••••••</td>
                            <td className="subadmin-role">{admin.role}</td>
                            <td>
                              <span className={`subadmin-badge ${admin.status === 'ENABLED' ? 'subadmin-badge-active' : 'subadmin-badge-inactive'}`}>
                                {admin.status === 'ENABLED' ? 'Active' : 'Disabled'}
                              </span>
                            </td>
                            <td>
                              <div className="subadmin-actions">
                                <button className="subadmin-edit-btn" onClick={() => sgcOpenEdit(admin)}>
                                  <FiEdit2 />
                                </button>
                                <button className="subadmin-delete-btn" onClick={() => deleteSubAdmin(admin.id)}>
                                  <FiTrash2 />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </Col>
          </Row>

        </Container>
      </div>

      {/* ── ADD MODAL (Portal) ───────────────────────────────── */}
      {sgcShowAdd && createPortal(
        <div className="subadmin-modal-overlay" onClick={() => setSgcShowAdd(false)}>
          <div className="subadmin-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="subadmin-modal-header">
              <h5 className="subadmin-modal-title">Add New Sub-Admin</h5>
              <button className="subadmin-modal-close" onClick={() => setSgcShowAdd(false)}>×</button>
            </div>

            <div className="subadmin-modal-body">
              <Row>
                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Name</label>
                    <input
                      className="subadmin-form-input"
                      type="text"
                      placeholder="Enter full name"
                      value={Name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Email</label>
                    <input
                      className="subadmin-form-input"
                      type="email"
                      placeholder="Enter email address"
                      value={Email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Password</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        className="subadmin-form-input"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter password"
                        value={Password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{ paddingRight: '44px' }}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(p => !p)}
                        style={{
                          position: 'absolute', right: '14px', top: '50%',
                          transform: 'translateY(-50%)', background: 'none',
                          border: 'none', color: '#6b8f80', cursor: 'pointer'
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Role</label>
                    <select
                      className="subadmin-form-select"
                      value={Role}
                      onChange={(e) => setRole(e.target.value)}
                    >
                      <option value="">Select role</option>
                      <option value="Sub Admin">Sub Admin</option>
                      <option value="Moderator">Moderator</option>
                    </select>
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Status</label>
                    <select
                      className="subadmin-form-select"
                      value={Status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="">Select status</option>
                      <option value="ENABLED">Enabled</option>
                      <option value="DISABLED">Disabled</option>
                    </select>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="subadmin-modal-footer">
              <button className="subadmin-modal-cancel-btn" onClick={() => setSgcShowAdd(false)}>Cancel</button>
              <button className="subadmin-modal-save-btn" onClick={createSubAdmin} disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save'}
              </button>
            </div>

          </div>
        </div>,
        document.body
      )}

      {/* ── EDIT MODAL (Portal) ──────────────────────────────── */}
      {sgcShowEdit && createPortal(
        <div className="subadmin-modal-overlay" onClick={() => setSgcShowEdit(false)}>
          <div className="subadmin-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="subadmin-modal-header">
              <h5 className="subadmin-modal-title">Edit Sub-Admin</h5>
              <button className="subadmin-modal-close" onClick={() => setSgcShowEdit(false)}>×</button>
            </div>

            <div className="subadmin-modal-body">
              <Row>
                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Name</label>
                    <input
                      className="subadmin-form-input"
                      type="text"
                      placeholder="Enter full name"
                      value={Name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Email</label>
                    <input
                      className="subadmin-form-input"
                      type="email"
                      placeholder="Enter email address"
                      value={Email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Password</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        className="subadmin-form-input"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter password"
                        value={Password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{ paddingRight: '44px' }}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(p => !p)}
                        style={{
                          position: 'absolute', right: '14px', top: '50%',
                          transform: 'translateY(-50%)', background: 'none',
                          border: 'none', color: '#6b8f80', cursor: 'pointer'
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Role</label>
                    <select
                      className="subadmin-form-select"
                      value={Role}
                      onChange={(e) => setRole(e.target.value)}
                    >
                      <option value="">Select role</option>
                      <option value="Sub Admin">Sub Admin</option>
                      <option value="Moderator">Moderator</option>
                    </select>
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="subadmin-form-group">
                    <label className="subadmin-form-label">Status</label>
                    <select
                      className="subadmin-form-select"
                      value={Status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="">Select status</option>
                      <option value="ENABLED">Enabled</option>
                      <option value="DISABLED">Disabled</option>
                    </select>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="subadmin-modal-footer">
              <button className="subadmin-modal-cancel-btn" onClick={() => setSgcShowEdit(false)}>Cancel</button>
              <button className="subadmin-modal-save-btn" onClick={updateSubAdmin} disabled={isLoading}>
                {isLoading ? 'Updating...' : 'Update'}
              </button>
            </div>

          </div>
        </div>,
        document.body
      )}

    </AdminLayout>
  );
};

export default SubAdmins;